export { default } from "./RegistrationMethod";